import React, { Component } from "react";
import Carousel from "nuka-carousel";
import styled from "styled-components";
import BannerBackground from "./BannerBackground";
import BannerImage from "./BannerImage";

class BannersCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slideIndex: 0,
      mount: false
    };
  }

  componentDidMount() {
    this.setState({ mount: true });
    this.timer = setInterval(this._checkDimension, 500);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    let { banners } = this.props;
    let { mount } = this.state;

    if (!mount) {
      return (
        <Wrapper>
          <div
            style={{ width: "100%", height: "100%", backgroundColor: "#fff" }}
          />
        </Wrapper>
      );
    }

    return (
      <Wrapper>
        <Carousel
          autoplay={true}
          initialSlideHeight={"auto"}
          renderBottomCenterControls={() => false}
          renderCenterLeftControls={this._renderLeftIcon}
          renderCenterRightControls={this._renderRightIcon}
          afterSlide={slideIndex => this._updateSlideIndex(slideIndex)}
        >
          {banners.map((banner, idx) =>
            banner.method === "background" ? (
              <BannerBackground key={"background-banner" + idx} data={banner} />
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
                key={idx}
              >
                <BannerImage
                  key={"img-banner" + idx}
                  data={banner}
                  height={"auto"}
                />
              </div>
            )
          )}
        </Carousel>
      </Wrapper>
    );
  }

  _checkDimension = () => {
    const nextWidth = window.innerWidth;
    if (nextWidth !== this.screenWidth) {
      this.screenWidth = nextWidth;
      this.forceUpdate();
    }
  };

  _renderLeftIcon = ({ previousSlide }) => {
    let { slideIndex } = this.state;
    return (
      <IconContainer
        onClick={
          slideIndex === 0
            ? () => this.setState({ slideIndex: 3 })
            : previousSlide
        }
        css="margin-left: 10px; transfrom: rotate(180deg); -webkit-transform: rotate(180deg); -moz-transform: rotate(190deg);"
      >
        <IconImage src="/images/pages/landing/icon10.png" />
      </IconContainer>
    );
  };

  _renderRightIcon = ({ nextSlide }) => {
    return (
      <IconContainer onClick={nextSlide} css="margin-right: 10px;">
        <IconImage src="/images/pages/landing/icon10.png" />
      </IconContainer>
    );
  };

  _updateSlideIndex = slideIndex => {
    let { banners } = this.props;
    if (slideIndex + 1 === banners.length) {
      setTimeout(() => this.setState({ slideIndex: 0 }), 3000);
    } else {
      this.setState({ slideIndex });
    }
  };
}

const Wrapper = styled.div`
  width: 100%;
  height: ${600 + 1}px;
  overflow: hidden;

  @media screen and (max-width: 1024px) {
    height: ${450 + 1}px;
  }

  @media screen and (max-width: 600px) {
    height: ${400 + 1}px;
  }

  @media screen and (max-width: 550px) {
    height: ${280 + 1}px;
  }

  @media screen and (max-width: 320px) {
    height: ${250 + 1}px;
  }

  ${props => props.css || ""};
`;

const IconContainer = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
  border: 0px;
  background-color: transparent;
  width: 40px;
  height: 40px;

  :focus {
    outline: none;
  }

  ${props => props.css || ""};
`;

const IconImage = styled.img`
  width: 20px;
  height: 20px;
`;

export default BannersCarousel;
